module.exports = __webpack_public_path__ + "static/mr-concert-performance-17-7c88f7ae56ee7ae0189e58430485fa5a.jpg";